<!-- 驼铃杯 课程详情 -->
<template>
    <div class="detail">
        <video v-if="needDownUrl" :src="downloadURLImg+$route.query.url" controls></video>
        <video v-else :src="$route.query.url" controls></video>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                needDownUrl:true
            }
        },
        methods: {},
        mounted() {},
        watch:{
            $route:{
                handler(oldVal){
                    if(oldVal.query.url.slice(0,4)=='http'){
                        this.needDownUrl = false
                    }else{
                        this.needDownUrl = true
                    }
                },
                deep:true,
                immediate:true
            }
        }
    };
</script>
<style lang='less' scoped>
    .detail {
        width: 1200px;
        margin: 20px auto;
        video{
            width: 100%;
        }
    }
</style>